import { z } from 'zod';
import { PracticePreferenceKeySchema } from './key.js';
/** Clears one preference on the named rows, so they fall back to what they inherit. */
export const PracticePreferenceOverrideBodySchema = z
    .object({
    attribute: PracticePreferenceKeySchema,
    preferenceIds: z.array(z.uuid()),
})
    .strict();
//# sourceMappingURL=override.js.map